import React from "react";

/**
 * CRYPTOBOOM mascot — official 3D artwork loaded from /mascot.png.
 * Props:
 *   - size: pixel size (square)
 *   - floating: enables gentle float animation
 *   - glow: render a green neon halo behind the mascot
 */
export default function Mascot({ size = 120, floating = true, glow = true }) {
  return (
    <div
      className={`relative inline-block ${floating ? "cb-float" : ""}`}
      style={{ width: size, height: size }}
      data-testid="mascot"
      aria-label="CRYPTOBOOM mascot"
    >
      {glow && (
        <div
          aria-hidden="true"
          className="absolute inset-0 rounded-full"
          style={{
            background:
              "radial-gradient(closest-side, rgba(46,204,113,0.55), rgba(46,204,113,0.12) 60%, transparent 75%)",
            filter: "blur(6px)",
            transform: "scale(1.1)",
          }}
        />
      )}
      <img
        src="/mascot.png?v=2"
        alt="CRYPTOBOOM"
        draggable="false"
        width={size}
        height={size}
        className="relative select-none"
        style={{
          width: size,
          height: size,
          filter:
            "drop-shadow(0 6px 14px rgba(0,0,0,0.45)) drop-shadow(0 0 18px rgba(46,204,113,0.35))",
        }}
      />
    </div>
  );
}
